import * as actions from "./actionsType";

const initialData = {
  loaderStatus: false,
  status: null,
  statusFalla: null,
  saveLoaderStatus: false,
  statusFormError: null,
};

export default function StatusReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_STATUS:
      return { ...state, loaderStatus: action.payload };

    case actions.GET_STATUS:
      return { ...state, status: action.payload };

    case actions.STATUS_FALLA:
      return { ...state, statusFalla: action.payload };

    case actions.SAVE_LOADER_STATUS:
      return { ...state, saveLoaderStatus: action.payload };

    case actions.FORM_STATUS_FAIL:
      return { ...state, statusFormError: action.payload };

    default:
      return state;
  }
}
